import { translationsDashboard_en_part1 } from "./translationsDashboard.en.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationsDashboard_en_part2 } from "./translationsDashboard.en.part2";
import { translationsDashboard_en_aiModelCalls } from "./translationsDashboard.en.aiModelCalls";

export const translationsDashboard_en = defineTranslationTree({
  ...translationsDashboard_en_part1,
  ...translationsDashboard_en_part2,
  ...translationsDashboard_en_aiModelCalls,
});
